<section>
  <app-player-basic-info [player]="player">
    <app-card-grid
      [cards]="cards"
    ></app-card-grid>
  </app-player-basic-info>
  <div class="tables">
    <div class="table-container">
      <p-table
        [value]="playerPerformanceLast5MatchesTableData"
        [tableStyle]="{ width: '100%' }"
        [size]="'large'"
        stripedRows
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="homeTeam">
              Fecha lesión <p-sortIcon field="homeTeam" />
            </th>
            <th pSortableColumn="goalScored">
              Fecha alta <p-sortIcon field="goalScored" />
            </th>
            <th pSortableColumn="assists">
              Descripción <p-sortIcon field="assists" />
            </th>
            <!-- <th pSortableColumn="turnovers"> -->
            <!--   Perdidas <p-sortIcon field="turnovers" /> -->
            <!-- </th> -->
            <!-- <th pSortableColumn="sanctions"> -->
            <!--   Sanciones <p-sortIcon field="sanctions" /> -->
            <!-- </th> -->
            <!-- <th pSortableColumn="minutesPlayed"> -->
            <!--   Minutos Jugados <p-sortIcon field="minutesPlayed" /> -->
            <!-- </th> -->
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr>
            <td>{{item.startDate | date}}</td>
            <td>{{ item.endDate | date}}</td>
            <td>{{ item.desc }}</td>
            <!-- <td>{{ item.turnovers }}</td> -->
            <!-- <td>{{ item.sanctions }}</td> -->
            <!-- <td>{{ item.minutesPlayed }}</td> -->
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>
